import { render, staticRenderFns } from "./IotSetupSidebar.vue?vue&type=template&id=535dba8d&scoped=true"
import script from "./IotSetupSidebar.vue?vue&type=script&lang=js"
export * from "./IotSetupSidebar.vue?vue&type=script&lang=js"
import style0 from "./IotSetupSidebar.vue?vue&type=style&index=0&id=535dba8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535dba8d",
  null
  
)

export default component.exports